function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "9ybrqy2d7a",
  d: "M15 8.25H5.872l4.193-4.192L9 3 3 9l6 6 1.057-1.057L5.872 9.75H15z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "3u0zna9emb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#9ybrqy2d7a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#3u0zna9emb)",
  fill: "#72246C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-9.75-9.75h37.5v37.5h-37.5z"
})));
const SvgIconUiIconsIcArrowBack = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUiIconsIcArrowBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-ui-icons-ic-arrow-back.2a548fc1.svg";
export { ForwardRef as ReactComponent };